import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'cmpts-dropdownbox',
  templateUrl: './dropdownbox.component.html',
  styleUrls: ['./dropdownbox.component.css']
})
export class DropdownboxComponent implements OnInit {
  language = new FormControl();
  bordersControl = new FormControl();

  languages: string[] = ['Spanish(Spain)', 'French', 'Spanish', 'Italian', 'German'];
  languageList:string[]=['English']
  constructor() { }

  ngOnInit(): void {
  }

  onLanguageChange(event){
    this.languageList=['English']
    this.languageList=[...this.languageList,...event.value]
  }
  ngOnChanges(changes: any):void{
    this.languageList=['English']
    this.languageList=[ this.languageList,...changes.languageList]
  }
}
